import React, { useState } from "react";
import Marquee from "react-fast-marquee";
import { useSelector } from "react-redux";
import { useInterval } from "../../hooks/useInterval";
import { COMPONENTS } from "../../_constants";
import { ContainersEntity } from "../../_entities";

const { getTicker } = ContainersEntity.selectors;

const Ticker = () => {
  const ticker = useSelector(getTicker);
  const [color, setColor] = useState("green");

  useInterval(() => {
    setColor(color === "green" ? "red" : "green");
  }, 7542);

  return (
    <div>
      <Marquee
        speed={100}
        gradient={false}
        style={{ backgroundColor: "black", height: "5vmin" }}
      >
        {ticker.map((item) => (
          <div key={item.id} className={`${color} mr5 f3`}>
            {item.__component === COMPONENTS.QUOTES && (
              <div className="flex">
                <p>"{item?.quote}"</p>
                {item?.quotee && (
                  <>
                    &nbsp;–&nbsp; <span>{item?.quotee}</span>
                  </>
                )}

                {color === "green" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="feather feather-triangle ml3"
                  >
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="feather feather-triangle ml3"
                    style={{ transform: "rotate(180deg)" }}
                  >
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                  </svg>
                )}
              </div>
            )}
          </div>
        ))}
      </Marquee>
    </div>
  );
};

export default Ticker;
